import { AccommodationProviderEnum } from './enums/accommodation-provider.enum';

export class AccommodationBooking {
  id?: string | null;
  accommodationProvider: AccommodationProviderEnum;
  '@type'?: string;
}
